import { IResourceContext } from 'shell-models-lib';
import { IDataFlowPOParser, IDataFlowPOParserWorkerOptions } from './IDataFlowPOParser';
import {
    DataFlowPlainObjectParser,
    IDataFlowPlainObjects
} from 'worker/app-workers/shared/models/dataflow-plainObject-parser';

export class LocalDataFlowPOParser implements IDataFlowPOParser {
    public async parseDSL(contextData: IResourceContext, script: string, dataFlowName: string, option?: Partial<IDataFlowPOParserWorkerOptions>): Promise<IDataFlowPlainObjects> {
        if (!option) {
            option = {};
        }
        const parser = new DataFlowPlainObjectParser();
        return parser.parseDataFlowScript(script, option);
    }
}
